<template>

  <section class="o-section">
    <div class="o-section__wrapper is-bottom-left" ref="wrapper">

      <div class="o-section__text" v-if="active">
        <div ref="textA" data-scene="9a">
          <div v-for="(line, index) in copy.top" v-html="line" :key="`${line}-${index}`"></div>
        </div>
        <div ref="textB" data-scene="9b">
          <div v-for="(line, index) in copy.bottom" v-html="line" :key="`${line}-${index}`"></div>
        </div>
      </div>

      <div class="o-section__figure-wrapper" v-if="active">
        <figure class="o-section__figure" ref="figureC" data-scene="9c">
          <Img :src="require('@/assets/scene9/spread9_c.png')" filename="spread9_c" />
        </figure>

        <figure class="o-section__figure anim-scene-9-a2" ref="figureA2" data-scene="9a2">
          <Img :src="require('@/assets/scene9/spread9_a2.png')" filename="spread9_a2" />
        </figure>

        <figure class="o-section__figure anim-scene-9-a3" ref="figureA3" data-scene="9a3">
          <Img :src="require('@/assets/scene9/spread9_a3.png')" filename="spread9_a3" />
        </figure>

        <figure class="o-section__figure" ref="figureA" data-scene="9a">
          <Img :src="require('@/assets/scene9/spread9_a.png')" filename="spread9_a" />
        </figure>

        <figure class="o-section__figure" ref="figureB" data-scene="9b">
          <Img :src="require('@/assets/scene9/spread9_b.png')" filename="spread9_b" />
        </figure>
      </div>
    </div>
  </section>

</template>

<script>
import Img from '@/components/Img'

export default {
  name: 'Scene9',
  props: ['options', 'active', 'copy', 'disableBlur'],

  mounted () {
    this.$root.$on('startScene9', () => {
      this.init()
    })
  },

  methods: {
    init () {
      this.$anime({
        targets: [this.$refs.figureA, this.$refs.figureA2, this.$refs.figureA3],
        translateX: ['-70px', '0'],
        translateY: ['10px', '0'],
        delay: 150,
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      this.$anime({
        targets: [this.$refs.figureA, this.$refs.figureA2, this.$refs.figureA3],
        opacity: [0, 1],
        delay: 150,
        duration: this.options.durationSmall,
        easing: this.options.easing
      })

      setInterval(() => {
        this.$anime({
          targets: this.$refs.figureA3.querySelector('div'),
          rotate: ['0', '-4deg'],
          duration: 750,
          easing: this.options.easing,
          direction: 'alternate',
          loop: 1
        })

        this.$anime({
          targets: this.$refs.figureA2.querySelector('div'),
          rotate: ['0', '5deg'],
          duration: 750,
          easing: this.options.easing,
          loop: 1,
          direction: 'alternate'
        })
      }, 2000)

      this.$anime({
        targets: this.$refs.figureB,
        translateX: ['40px', '0'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      if (this.disableBlur) {
        this.$anime({
          targets: this.$refs.figureB,
          opacity: [0, 1],
          delay: 150,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureC,
          opacity: [0, 1],
          delay: 200,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: this.$refs.figureB,
          filter: ['blur(10px)', 'blur(0px)'],
          delay: 150,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureC,
          filter: ['blur(5px)', 'blur(0px)'],
          delay: 200,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      }

      this.$anime({
        targets: this.$refs.figureC,
        translateX: ['80px', '0'],
        translateY: ['-10px', '0'],
        delay: 200,
        duration: this.options.durationLarge,
        easing: this.options.easing
      })
    }
  },

  components: {
    Img
  }
}
</script>
